import { useState } from "react";
import { Box, Typography, Button, Chip } from "@mui/material";
import Background from "../../../components/Background";
import Topnav from "../../../components/Topnav";
import CopyRightTextMain from "../../../components/CopyRightTextMain";
import "./EmploymentStatus.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { employmentOptions } from "../../../constants/CreateProfileLists";
import { updateFields } from "../../../redux/profileSlice";
import { useEditableProfile } from "../../../hooks/useEditableProfile";

const EditEmploymentStatus = () => {
  const [error, setError] = useState(false);

  // Router state when opened from the Profile UI, the stored profile on a
  // reload or a pasted link (ECH-387). `RequireProfileLoaded` guarantees one
  // of them exists before this component mounts, so the initialisers below
  // are safe to dereference.
  const { profile: localProfile } = useEditableProfile();
  const profile = localProfile?.profile ?? {};

  const [selected, setSelected] = useState(profile.employmentStatuses ?? []);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const handleSelect = (emps) => {
    error && setError(false);
    let employmentStatusArr;
    if (selected.includes(emps)) {
      employmentStatusArr = selected.filter((status) => status !== emps);
    } else {
      if (selected.length < 2) {
        employmentStatusArr = [...selected, emps];
      } else {
        setError(true);
        return;
      }
    }
    setSelected(employmentStatusArr);
    dispatch(
      updateFields({
        field: "employmentStatuses",
        value: employmentStatusArr,
      }),
    );
  };

  if (!localProfile) {
    return <div>No profile data found.</div>;
  }
  return (
    <Background>
      <Topnav />
      <Box
        sx={{
          maxWidth: {
            xs: "95 !important",
            sm: "650px !important",
          },
        }}
        className="emp-selection-box"
      >
        {/* Title */}
        <Typography
          className="text-primary"
          variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: {
              xs: "18px",
              sm: "20px",
              md: "24px",
              lg: "26px",
              xl: "32px",
            },
          }}
          gutterBottom
        >
          Employment Status
        </Typography>

        {/* Subtitle */}
        <Typography
          variant="body"
          display="inline-block"
          sx={{
            fontWeight: 400,
            fontSize: "16px",
            color: "#152134",
          }}
          gutterBottom
        >
          Select the option(s) that best describes your current employment
          status.
        </Typography>
        <Typography
          variant="body"
          display="inline-block"
          sx={{
            fontWeight: 400,
            fontSize: "16px",
            color: "#152134",
            paddingBottom: "20px",
          }}
        >
          Select up to 2
        </Typography>

        {/* Options as Chips */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            justifyContent: "center",
          }}
        >
          {employmentOptions.map((option) => (
            <Chip
              //className="hover-tag-color"
              key={option}
              label={option}
              clickable
              variant={selected?.includes(option) ? "filled" : "outlined"}
              color={selected?.includes(option) ? "primary" : "default"}
              onClick={() => handleSelect(option)}
              sx={{
                background: selected?.includes(option)
                  ? "#7BB9D5 !important"
                  : "#ffffff",
                borderColor: selected?.includes(option) ? "#7BB9D5" : "#AAB6C8",
                fontWeight: selected?.includes(option) ? 600 : 400,
                paddingX: 1.5,
                borderRadius: "50px",
                textTransform: "capitalize",
                height: {
                  xs: "40px",
                  sm: "45px",
                  md: "45px",
                  lg: "50px",
                  xl: "66px",
                },
                color: "#2A4876",
                fontSize: {
                  xs: "14px",
                  sm: "15px",
                  md: "16px",
                  lg: "16px",
                  xl: "20px",
                },
              }}
            />
          ))}
        </Box>
        {error && (
          <Typography sx={{ color: "red", marginTop: "15px" }}>
            Maximum 2 selections allowed!
          </Typography>
        )}

        {/* Next Button */}
        <Button
          onClick={() => navigate("/profile/edit-profile")}
          variant="contained"
          fullWidth
          className="Send-button next-btn-employment"
          disabled={selected.length === 0}
          sx={{
            backgroundColor: selected ? "#2A4876" : "#AAB6C8", // Change color based on input values
            cursor: selected ? "pointer" : "not-allowed", // Disable hover effect when fields are not filled
            color: "#fff",
            marginTop: "20px !important",
          }}
        >
          Save
        </Button>
      </Box>
      <CopyRightTextMain />
    </Background>
  );
};

export default EditEmploymentStatus;
